import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { FieldModel } from '../model/field.model';

export function maxDecimalPlacesValidator(maxDecimalPlaces: number): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const value = control.value;

		if (value === null || value === undefined || value === '') {
			return null;
		}

		const decimalPart = value.toString().split('.')[1];
		const isInvalid = !!decimalPart && decimalPart.length > maxDecimalPlaces;

		if (!isInvalid) {
			return null;
		}

		return {
			maxDecimalPlaces: {
				message: `Only ${maxDecimalPlaces} decimal place(s) are allowed`,
				maxDecimalPlaces
			}
		};
	};
}
